import {create} from 'zustand';

export interface VideoPlaybackState {
  currentTime: number;
  isPlaying: boolean;
}

const initialState: VideoPlaybackState = {
  currentTime: 0,
  isPlaying: false,
};

const videoPlaybackStore = create<VideoPlaybackState>(() => initialState);

export const videoPlaybackActions = {
  setCurrentTime: (time: number) =>
    videoPlaybackStore.setState({currentTime: time}),
  setIsPlaying: (playing: boolean) =>
    videoPlaybackStore.setState({isPlaying: playing}),
  resetCurrentTime: () => videoPlaybackStore.setState({currentTime: 0}),
  reset: () => videoPlaybackStore.setState(initialState),
};

export default videoPlaybackStore;
